import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { ThemeProvider } from './contexts/ThemeContext.tsx';
import { GosadAuthProvider } from './contexts/GosadAuthContext.tsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GosadAuthProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </GosadAuthProvider>
  </React.StrictMode>
);
